var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppIconGprMounted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1240,
    height: 1240,
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "appIconGPRMounted_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1240v1240H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Proceq GM \\u2013 Rounded",
    clipPath: "url(#appIconGPRMounted_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0)",
    d: "M0 0h1240v1240H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "App Rounded"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 7",
    width: 1240,
    height: 1240,
    rx: 212,
    fill: "#009ca6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M239.413 451h-50.7a50.15 50.15 0 00-22.312 5.143 61.226 61.226 0 00-18.89 14.091c-.994 1.051-1.778 2.409-2.7 3.575q-14.655 16.863-15.621 40.514c-.076 1.071-.191 2.122-.191 3.231v208.133a67.552 67.552 0 005.181 26.1c.364.822.822 1.568 1.243 2.409a44.026 44.026 0 001.931 3.766 68.846 68.846 0 0010.152 15.028 61.355 61.355 0 0018.89 14.129c7.074 3.423 15.448 6.615 23.229 6.615h251.573v34.492c0 15.047-7.494 22.58-22.56 22.58H241.421v88.2h243.771c18.622 0 34.51-5.143 47.492-15.371q19.474-15.429 19.483-43.4V451zm201.346 150.259v78.637c0 15.468-6.9 23.9-20.668 23.9l-67.587-.018h-90.453c-13.767 0-20.63-6.329-20.63-21.834v-117.93q0-23.317 20.63-23.345h158.04q20.649 0 20.668 23.345z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "M609.056 789.001h107.915V540.184h58.819c14.9 0 22.357 7.175 22.357 21.6v227.217h102.76V540.184h65.58c14.917 0 22.338 7.175 22.338 21.6v227.217h109.558V518.526c0-9.479-1.68-19.393-5.06-27.286a75.986 75.986 0 00-13.2-20.96 57.867 57.867 0 00-18.958-14.181 50.16 50.16 0 00-21.6-5.1H915.806q-27.729 0-47.018 18.958c-12.859 12.578-19.279 29.648-19.279 48.569a69.983 69.983 0 00-5.023-26.606 74.2 74.2 0 00-13.558-20.96c-5.646-6.1-11.972-11.481-18.939-14.861a48.22 48.22 0 00-21.3-5.1h-125.74c-1.7.076-3.323.453-5 .661a47.065 47.065 0 00-14.5 4.1 60.655 60.655 0 00-18.335 13.671 68.777 68.777 0 00-13.048 20.752 64.668 64.668 0 00-5 25.114l-.056.245v53.023h.056z",
    fill: "#fff"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGprMounted);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconGPRMounted.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };